module.exports = __webpack_public_path__ + "img/emj_skolkovo.62b5ef6.svg";